import { Controller } from "stimulus";

// "Nova conversa" modal chrome: open/close and the channel toggle. The recipient search, paging
// and selection live in the importmap `recipient-picker` controller on the same form. Hosted by
// the turbo-modal frame over any page (closing empties the frame) or by the new page itself.
export default class extends Controller {
  static targets = ["overlay", "chanLabel"];

  open() {
    if (this.hasOverlayTarget) this.overlayTarget.hidden = false;
  }

  close() {
    const frame = this.element.closest("turbo-frame");
    if (frame) {
      frame.innerHTML = "";
      return;
    }
    if (this.hasOverlayTarget) this.overlayTarget.hidden = true;
  }

  closeOnBackdrop(event) {
    if (event.target === this.overlayTarget) this.close();
  }

  pickChannel(event) {
    const label = event.currentTarget;
    const input = label.querySelector("input");
    if (input.disabled) return;

    this.chanLabelTargets.forEach((el) => el.classList.toggle("is-on", el === label));
    input.checked = true;
  }
}
